import { useEffect } from "react";
import DigitalReceptionistSection from "@/components/sections/DigitalReceptionistSection";

export default function DigitalReceptionist() {
    useEffect(() => {
        document.title = "Digital Receptionist · A1 Screening Naples FL";
        const meta = document.querySelector('meta[name="description"]');
        if (meta) {
            meta.setAttribute(
                "content",
                "Route your pool cage or lanai screen request directly to A1 Screening's priority queue. Every request is sorted into a tier and routed for technician review during business hours.",
            );
        }
    }, []);

    return <DigitalReceptionistSection />;
}
